const brandSiteConfig = {
  bilkaUrl:
    import.meta.env.VITE_APP_BILKA_URL || 'https://deploy-preprod--bilka.netlify.app/',
  brUrl: import.meta.env.VITE_APP_BR_URL || 'https://deploy-preprod--next-br.netlify.app/',
  foetexUrl:
    import.meta.env.VITE_APP_FOETEX_URL || 'https://deploy-preprod--foetex.netlify.app/',
};

export { brandSiteConfig };
